var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#E62048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12399 15H11.876C12.3844 14.7179 12.8589 14.382 13.2916 14H2.70835C3.14114 14.382 3.61559 14.7179 4.12399 15zM1.75463 13H14.2454C14.4977 12.6853 14.7267 12.3511 14.9297 12H1.07026C1.27334 12.3511 1.50234 12.6853 1.75463 13zM.581517 11H15.4185C15.5494 10.6766 15.6597 10.3428 15.748 10H.252035C.340256 10.3428.450622 10.6766.581517 11zM.0618938 9H15.9381C15.979 8.67241 16 8.33866 16 8H0C0 8.33866.0210433 8.67241.0618938 9zM.0618937 7H15.9381C15.8957 6.65956 15.8318 6.32577 15.748 6H.252035C.168189 6.32577.104346 6.65956.0618937 7zM.581517 5H15.4185C15.2784 4.65398 15.1148 4.31998 14.9297 4H1.07026C.885157 4.31998.721584 4.65398.581517 5zM1.75463 3H14.2454C13.9567 2.63985 13.6375 2.30521 13.2916 2H2.70835C2.36255 2.30521 2.04334 2.63985 1.75463 3zM4.12399 1H11.876C10.7278.362837 9.40625 0 8 0 6.59375 0 5.27224.362837 4.12399 1z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8H8V0C3.58172 0 0 3.58172 0 8Z",
    fill: "#2B63D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M.0620117 7H1.00012V6H.252153C.168307 6.32577.104464 6.65956.0620117 7zM1.00012 4.12399V5H2.00012V4H1.07038C1.0466 4.0411 1.02318 4.08243 1.00012 4.12399zM2.00012 2.70835V3H3.00012V2H2.70847C2.45789 2.22116 2.22128 2.45778 2.00012 2.70835zM6.00012 2H7.00012V3H6.00012V2zM6.00012 4H5.00012V5H6.00012V4zM3.00012 6H2.00012V7H3.00012V6zM5.00012 6H4.00012V7H5.00012V6zM6.00012 6H7.00012V7H6.00012V6zM4.00012 4H3.00012V5H4.00012V4zM4.00012 2H5.00012V3H4.00012V2z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8C15.75 12.2802 12.2802 15.75 8 15.75C3.71979 15.75 0.25 12.2802 0.25 8C0.25 3.71979 3.71979 0.25 8 0.25C12.2802 0.25 15.75 3.71979 15.75 8Z",
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
}

export default SvgCom;